import * as React from 'react';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { UIComponentState } from '../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { GridComponent, GridComponentProps } from '../../../toolkit/grid/gridcomponent';
import { TabViewModelImpl } from '../../../toolkit/tabs/tab/tabviewmodel';
import { GridPaginationListViewModel } from '../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';
import { GridPaginationComponent } from '../../../toolkit/grid/gridpagination/gridpaginationcomponent';


export class LandingPageTabViewModelImpl extends TabViewModelImpl {
    private ref: GridComponent<GridComponentProps<ToneDto>, UIComponentState>;
    private paginationComponent: GridPaginationComponent<ToneDto>;

    constructor(private categoryId: number, private context: BaseContext, private title: string,
        private listViewModel: GridPaginationListViewModel<ToneDto>, private onLoadMore: any) {
        super();
        this.onPageSelected = this.onPageSelected.bind(this);
    }

    getTitle(): string {
        return this.title;
    }

    getTabView(): JSX.Element {
        return (
            <>
                <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.listViewModel} context={this.context} />
                <div style={{ height: "50px", width: "100%", marginTop: "100px" }}>
                    <GridPaginationComponent ref={(item: any) => this.paginationComponent = item} onPageSelected={this.onPageSelected} listViewModel={this.listViewModel} context={this.context} />
                </div>
            </>);
    }

    onPageSelected(startIndex: number, offset: number) {
        this.onLoadMore(this.categoryId, startIndex, offset);
    }

    updateTabData(listOfDatas: ToneDto[]) {
        this.listViewModel.getListOfDatas().length = 0;
        this.listViewModel.setListDatas(listOfDatas);

        this.listViewModel.resetPaginationState();

        this.ref !== null && this.ref !== undefined && this.ref.forceUpdateComponent();
    }

    updateLoadMoreTabData(listOfDatas: ToneDto[]) {
        this.listViewModel.getListOfDatas().length = 0;
        this.listViewModel.setListDatas(listOfDatas);

        this.paginationComponent !== null && this.paginationComponent.updatePaginationCount();
        this.ref !== null && this.ref !== undefined && this.ref.forceUpdateComponent();
    }
    deleteData(id: string) {
        this.listViewModel.deleteData(id);

        this.ref !== null && this.ref.forceUpdateComponent();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/landingpagelist/landingpagetabviewmodel.tsx